import AsSeenOn from './AsSeenOn';
export default AsSeenOn;
